var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-main-page" }, [
    _c("section", { staticClass: "login" }, [
      _c("figure", [
        _c("img", {
          attrs: {
            src: require("@/assets/img/apps_logo-tall.png"),
            alt: "ENK apps"
          }
        }),
        _vm._v(" "),
        _c("figcaption", [
          _vm._v(_vm._s(_vm._f("trans")("general:intro.welcome")))
        ])
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "login", attrs: { href: _vm.login } }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/ENKlogin.svg"),
            alt: _vm.$t("login")
          }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm._f("trans")("general:intro.login_continue")))])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "promo" }, [
      _c("h1", [_vm._v("Enkronos Apps")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm._f("trans")("general:intro.intro")))]),
      _vm._v(" "),
      _c(
        "a",
        { attrs: { href: "https://www.aquest.io", target: "_blank" } },
        [_c("svgICO", { staticClass: "promo" })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3325b84c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3325b84c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/Login.vue
// module id = null
// module chunks = 